// extracted by mini-css-extract-plugin
export default {"PasswordReset":"PasswordReset_PasswordReset__Ce2As","FormError":"PasswordReset_FormError__39JCL"};